import 'react';
import '../scss/gap-category.scss';

export default () => null;
